import { settleSample } from '~/widgets/CostBomDemo/engine/mountBomPanels'

/**
 * What React components use to reach the legacy engine.
 *
 * The engine exposes itself as functions on `window` and reports progress only
 * as `data-hero-phase` on the hero section. Components go through these typed
 * calls instead, so that surface lives in one place.
 */

export type HeroPhase = 'idle' | 'generating' | 'ready'

export function heroPhase(hero: HTMLElement): HeroPhase {
  return (hero.getAttribute('data-hero-phase') ?? 'idle') as HeroPhase
}

/** Calls `listener` whenever the engine moves the hero to another phase. */
export function onPhaseChange(
  hero: HTMLElement,
  listener: (phase: HeroPhase) => void,
): () => void {
  const observer = new MutationObserver(() => listener(heroPhase(hero)))
  observer.observe(hero, {
    attributes: true,
    attributeFilter: ['data-hero-phase'],
  })
  return () => observer.disconnect()
}

export function setProductImage(product: string) {
  window.setHeroProductImage?.(product)
}

/**
 * Shows one of the pre-rendered samples, without the loading skeleton. Does
 * nothing until the engine has inserted the panels.
 */
export function showSample(hero: HTMLElement, key: string) {
  if (!window.heroShowSample || !window.heroPanelsReady) return
  window.heroShowSample(key)
  settleSample(hero)
}
